export default new google.maps.StyledMapType([], {
    name: 'Light'
})